<template>
  <div id="layRight">
    <div class="statement">
      <div class="tsSystem" v-if="library_id==776">
        <div class="aqt_lang_mn titlefont" @click="getsSystem('zs')">{{ zs|U2M }}</div>
        <div class="aqt_lang_mn titlefont" @click="getsSystem('zr')">{{ zr|U2M }}</div>
      </div>
      <div class="foot_box">
        <p class="aqt_lang_mn titlefont" style="align-items: flex-end">{{ 'copyright@ ' + yesr |U2M }}<span
            style="margin: 3px 0; color: var(--themeColor);" @click="getAqt">{{
            $t('m.aqtkj')|U2M
          }}</span>{{ $t('m.bqsy')|U2M }}
        </p>
        <p class="titlefont" style="display: flex;flex-direction: column;align-items: flex-start"><span class="aqt_su">经营许可证编号</span><span
            class="aqt_lang_mn">{{ ":蒙ICP备160044441号-2" + $t('m.contact_information')|U2M }}</span></p>
      </div>

      <div class="mobile_phone">
        <div @click="goChinese" class="aqt_su" style="margin-bottom: 25px">中文端</div>
        <Poptip placement="left-end" popper-class="Poptip_phone" trigger="hover">
          <div class="aqt_lang_mn titlefont">{{ $t('m.mobile_phone_title')|U2M }}</div>
          <template #content>
            <img src="@/assets/images/eriweima.png">
          </template>
        </Poptip>
      </div>

    </div>


  </div>
</template>
<script>
export default {
  data() {
    return {
      yesr: '',
      tsxit: 'ᠡᠬᠡ ᠪᠢᠴᠢᠭ ᠬᠢᠨᠠᠬᠤ ᠰᠢᠰᠲ᠋ᠧᠮ',
      zs:'ᠭᠦᠨ ᠤᠬᠠᠭᠠᠨ ᠨᠡᠶᠢᠭᠡᠮ ᠦᠨ ᠰᠢᠨᠵᠢᠯᠡᠬᠦ ᠤᠬᠠᠭᠠᠨ ᠤ ᠬᠡᠪᠯᠡᠯ',//哲学社会科学版蒙古文
      zr:'ᠪᠠᠶᠢᠭᠠᠯᠢ ᠶᠢᠨ ᠰᠢᠨᠵᠢᠯᠡᠬᠦ ᠤᠬᠠᠭᠠᠨ ᠦ ᠮᠣᠩᠭᠣᠯ ᠬᠡᠪᠯᠡᠯ'//自然科学版蒙古文
    }
  },
  methods: {
    getAqt() {
      window.open('http://web.aqitai.com', '_blank');
      this.$store.dispatch('saveUserBehavior', {
        type: 0,
        path: this.$route.path,
        mark: '点击跳转官网按钮'
      }).then(() => {
      })
    },
    getsSystem(type) {
      let lib = localStorage.getItem('theme_color') ? JSON.parse(this.$crypto.get(localStorage.getItem('theme_color'))).library_id : ''
      let alis = type=='zs'?'zheshe':(type=='zr'?'ziran':'')
      if (lib) {
        window.open('http://ts.aqitai.com/#/login?lib=' + encodeURIComponent(this.$crypto.set(lib))+'&alis='+encodeURIComponent(this.$crypto.set(alis)), '_blank');
        // window.open('http://localhost:8081/#/home?lib=' + encodeURIComponent(this.$crypto.set(lib))+'&alis='+encodeURIComponent(this.$crypto.set(alis)), '_blank');

        this.$store.dispatch('saveUserBehavior', {
          type: 0,
          path: this.$route.path,
          mark: '点击跳转投审系统'
        }).then(() => {
        })
      }
    },

    goChinese(){
      let that = this
      localStorage.removeItem("lang");
      localStorage.setItem("lang", 'zh');
      that.$store.dispatch('getLangStore', 'zh').then(() => {
      })
      that.$router.replace({path: '/zhver', query: {lib_type: sessionStorage.getItem('gcm')}})
    }
  },
  computed: {
    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ? JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : "";
      return vv
    },
    // 用户id
    member_id() {
      let mm = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return mm
    },
  },
  created() {
    var date = new Date();
    this.yesr = date.getFullYear(); //获取当前年份(2位)
  }

}
</script>
<style lang="less" scoped>
#layRight {
  width: 92px;
  height: 100%;
  position: relative;

  .statement {
    min-width: 77px;
    height: 100%;
    background: #ffffff;
    position: absolute;
    right: 0;
    top: 0;

    .foot_box {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      p {
        width: 38px;
        height: 50%;
        font-size: 14px;
        color: #888888;
        line-height: 20px;
        display: flex;
        //align-items: center;
        justify-content: center;

        span {
          cursor: pointer;
        }
      }
    }

    .mobile_phone {
      //width: 77px;
      width: 100%;
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: var(--themeColor);
      font-size: 14px;
      cursor: pointer;
      position: absolute;
      bottom: 0;
    }

    .tsSystem {
      width: 100%;
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--themeColor);
      font-size: 12px;
      cursor: pointer;
      position: absolute;
      top: 0;
    }
  }


}
</style>

<style lang="less">
.Poptip_phone {
  img {
    width: 150px;
    height: auto;
  }

  .ivu-poptip-body {
    padding: 16px !important;
  }
}
</style>
